import { CognitoIdentityCredentials } from "@aws-sdk/credential-provider-cognito-identity";

import { getFreshTokensAndClaims, useMSALPayload } from "@initia-digital/auth-client-utils";
import { baseDefinedAndNotNullNarrowing } from "@initia-digital/ts-utils";
import { CredentialInput, WrapRefreshCredentials } from "@initia-digital/types/service";


export const wrapRefreshCognitoCredentialsUtil = (authDetail: Awaited<ReturnType<typeof useMSALPayload>>): WrapRefreshCredentials<CognitoIdentityCredentials> => async(refreshCredentials) => {
    // --------------------------------------------
    try {
        // -------------------------------------------
        const credentials = await refreshCredentials();
        return credentials;
    }
    catch (error) {
        // -------------------------------------------
        if (
            typeof error === 'object' && baseDefinedAndNotNullNarrowing(error)
            && 'name' in error && error.name === 'NotAuthorizedException'
            && 'message' in error && typeof error.message === 'string'
            && error.message.includes('Invalid login token. Token expired')
        ) {
            // -------------------------------------------
            const { msal } = authDetail;
            const { idToken } = await getFreshTokensAndClaims(msal, { scopes: ["openid", "profile", "User.Read", "User.Read.All", "offline_access"] }, true);
            const credentialsInput = {
                type: "CognitoIdentity",
                idToken,
                service: 'execute-api'
            } as CredentialInput;

            const credentials = await refreshCredentials(credentialsInput);
            return credentials;
        }
        throw error;
    }
}
